import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Textfield from "../shared/textfield";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore" ;
import moment from "moment";
import { buttonRed, dialogEditEvent, textFieldTitle } from "../../style2";

export default function EditEvent({
  open,
  handleClose,
  eventType,
  eventData,
  disabled = false,
}) {

  const [eventDataDialog, setEventDataDialog] = useState([]);

  useEffect(() => {
    setEventDataDialog(eventData);
  }, [eventData]);

  const handleDataChange = (e) => {
    //console.log("e data:", e.target.value);
    const { name, value } = e.target;
    setEventDataDialog((prevEventData) => ({
      ...prevEventData,
      [name]: value,
    }));
    //console.log("after edit", eventDataDialog);
  };

  const handleDateChange = (newDate) => {
    const date = new Date(newDate);

    // Extract day, month, and year
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    // Create the dd/mm/yyyy format
    const formattedDate = `${day}/${month}/${year}`;

    const eventData = eventDataDialog;
    eventData.date = formattedDate;
    setEventDataDialog(eventData);
  };
  const handleMedicationDateChange = (newDate, index) => {
    const updatedMedicationDates = [...eventDataDialog.medicationDates];
    updatedMedicationDates[index] = newDate;
    setEventDataDialog({
      ...eventDataDialog,
      medicationDates: updatedMedicationDates,
    });
  };
  const [showAccordion, setShowAccordion] = useState(false);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <Box sx={dialogEditEvent}>
        <Grid item xs={12} align="center">
          <DialogTitle sx={{ textTransform: "uppercase" }}>
            {disabled ? "View" : eventData === "" ? "Add" : "Edit"} {eventType}
          </DialogTitle>
        </Grid>
        <Box m={2} />
        <DialogContent style={{height:"380px" }}>
          {eventType === "Medication" && eventDataDialog.medicationDates ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>{eventDataDialog.medicineName}</Typography>
              </Grid>
              {eventDataDialog.medicationDates.map((date, index) => (
                <Accordion xs={12}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      {moment(date.startDate).format("DD.MM.YYYY")}
                    </Typography>{" "}
                  </AccordionSummary>
                  <AccordionDetails>
                    {date.medicationDosages && (
                      <Grid container>
                        <Grid item xs={6}>
                          <Typography variant="h6">Frequency</Typography>
                          {date.medicationDosages.map((dosageDetail) => (
                            <Typography key={dosageDetail.id}>
                              {dosageDetail.frequency}
                            </Typography>
                          ))}
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="h6">Dosage</Typography>
                          {date.medicationDosages.map((dosageDetail) => (
                            <Typography key={dosageDetail.id}>
                              {dosageDetail.dosage}
                            </Typography>
                          ))}
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="h6">Description</Typography>
                         
                            <Typography >
                              {date.description}
                            </Typography>
                          ))
                        </Grid>
                      </Grid>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Grid>
          ) : (
            <>
              <Grid container>
                <Grid item xs={12}>
                  <Textfield
                    title={
                      eventType === "Appointment"
                        ? "Appointment"
                        : eventType === "Todo"
                        ? "Name"
                        : ""
                    }
                    value={
                      eventType === "Appointment"
                        ? eventDataDialog.title
                        : eventType === "Todo"
                        ? eventDataDialog.title
                        : ""
                    }
                    name={eventType === "Appointment" ? "appointment_with" : ""}
                    onChange={(e) => handleDataChange(e)}
                    disabled={disabled}
                  />
                </Grid>
                <Box m={1} />
                <Grid item xs={12}>
                  <Textfield
                    title="Details"
                    rows={4}
                    maxCharacterLimit={200}
                    value={eventDataDialog.description}
                    name={eventType === "Todo" ? "details" : ""}
                    onChange={(e) => handleDataChange(e)}
                    disabled={disabled}
                  />
                  <Box m={1} />
                </Grid>
              </Grid>
              <Grid container item spacing={3}>
                <Grid item xs={5}>
                  <Typography sx={textFieldTitle}>
                    Date
                  </Typography>
                  <Box m={1} />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      slotProps={{ textField: { size: "small" } }}
                      value={dayjs(eventDataDialog.startDate)}
                      format="DD/MM/YYYY"
                      onChange={(newDate) => handleDateChange(newDate)}
                      disabled={disabled}
                      
                    />
                  </LocalizationProvider>
                </Grid>
                </Grid><Grid container item spacing={3}>
                <Grid item xs={4}>
                  <Typography sx={textFieldTitle}>
                    Start Time
                  </Typography>
                  <Box m={1} />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      slotProps={{ textField: { size: "small" } }}
                      value={eventDataDialog.startDate}
                      format="hh:mm A"
                      ampm={true}
                      disabled={disabled}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={textFieldTitle}>
                    End Time
                  </Typography>
                  <Box m={1} />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      slotProps={{ textField: { size: "small" } }}
                      value={eventDataDialog.endDate}
                      format="hh:mm A"
                      ampm={true}
                      disabled={disabled}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </>
          )}
        </DialogContent>

        <Box m={2} />
        <DialogActions>
          {disabled ? (
            <Grid container alignItems="center">
              <Grid item xs={12} container justifyContent="center">
                <Button sx={buttonRed} onClick={handleClose}>
                  Close
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container alignItems="center">
              <Grid item xs={6} container justifyContent="center">
                <Button sx={buttonRed} onClick={handleClose}>
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6} container justifyContent="center">
                <Button sx={buttonRed}>Save</Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}
